import React from 'react';

const LinkRenderer = (props) => (
	<a href={props.href} target='_blank' rel='noreferrer'>
		{props.children}
	</a>
);

export default LinkRenderer;
